export default __webpack_public_path__ + "static/media/pipesSolution.4f3e1303.png";